export default __webpack_public_path__ + "static/media/attivazione-saggio-nc.7b18c458.svg";